// extracted by mini-css-extract-plugin
export default {"search-container":"search-container___DA0NK","search-input":"search-input___qZ0sV","search-btn":"search-btn___gvw0U"};